module.exports = __webpack_public_path__ + "img/cooperate_30.7b63b68e.png";